// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../css/lex-web-ui-fullpage.css
// module id = ../css/lex-web-ui-fullpage.css
// module chunks = 0